import "./mp.css";
import { Link } from "react-router-dom";
import React, { useState, useEffect, Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import Chairman from "../images/Chairman.jpg";
import MainBg from "../images/Leadership main bg.jpg";
import men from "../images/men.png";
import Mobilemen from "../images/mobile-men.png";
import Ceo from "../images/Ojiromayo.jpg";
import ED from "../images/Abayomi.jpg";
import Internal from "../images/Yomi.jpg";
import InternalAud from "../images/Segun.jpg";
import RiskMMng from "../images/Kingsley.jpg";
import ready from "../images/avc-ready.jpg";
import benefits from "../images/avc-benefits.jpg";
import mpBanner from "../images/mp.jpg";
import mpFeatures from "../images/mp-features.jpg";
import mpSteps from "../images/mp-steps.jpg";
import mpStart from "../images/mp-start.jpg";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Footer from "./footer";
import AOS from 'aos';

import { ApolloClient, HttpLink, InMemoryCache, gql } from "@apollo/client";
import { ApolloProvider } from "@apollo/client/react";

const client = new ApolloClient({
  link: new HttpLink({
    uri: "https://pensure-cms.inspireleadership.biz/graphql",
  }),
  cache: new InMemoryCache(),
});

const Mp = () => {
  window.scrollTo(0, 0);

  const [heroBanner, setHeroBanner] = useState([]);
  const [heroMobile, setHeroMobile] = useState([]);
  const [listSections, setListSections] = useState([]);
  const [businessSections, setBusinessSections] = useState([]);
  const [productText, setProductText] = useState("");
  const [productTextContd, setProductTextContd] = useState("");

                    useEffect( () => {
                                     AOS.init({
                                        offset: 0,
                                        duration: 1000,
                                        once: true
                                 });
                                                  
                                                      
                                 }, [])

  useEffect(() => {
    client
      .query({
        query: gql`
          query NewQuery {
            pages(first: 100) {
              nodes {
                mp {
                  fieldGroupName
                  productText
                  productTextContd
                  hero {
                    buttonLink
                    buttonName
                    caption
                    heading
                    image {
                      mediaItemUrl
                    }
                  }
                  heromobile {
                    buttonLink
                    buttonName
                    caption
                    heading
                    image {
                      mediaItemUrl
                    }
                  }
                  listSection {
                    heading
                    image {
                      mediaItemUrl
                    }
                    list {
                      list
                    }
                  }
                  section {
                    buttonLink
                    buttonName
                    caption
                    heading
                    image {
                      mediaItemUrl
                    }
                  }
                }
              }
            }
          }
        `,
      })
      .then((result) => {
        console.log(result);

        setHeroBanner(result.data.pages.nodes[21].mp.hero);
        setHeroMobile(result.data.pages.nodes[21].mp.heromobile);
        setListSections(result.data.pages.nodes[21].mp.listSection);
        setBusinessSections(result.data.pages.nodes[21].mp.section);
        setProductText(result.data.pages.nodes[21].mp.productText);
        setProductTextContd(result.data.pages.nodes[21].mp.productTextContd);
      });
  }, []);

  let listSectionsDisplay;
  let heroBannerDisplay;
  let heroMobileBannerDisplay;
  let businessSectionsDisplay;

  if (heroBanner.length > 0) {
    heroBannerDisplay = heroBanner.map((banner, i) => (
      <div className="mp-cover">
        <img className="mp-bg" src={banner.image.mediaItemUrl} />
        <div className="mp-content">
          <div className="mp-txt">
            <h1 className="mp-h1 " data-aos="zoom-in" data-aos-delay="200"> {banner.heading} </h1>
            <p className="grey-p" data-aos="fade-up" data-aos-delay="200">{banner.caption}</p>
            <a href={banner.buttonLink} className="btn-trns" data-aos="fade-up" data-aos-delay="200">
              {" "}
              {banner.buttonName}{" "}
              <FontAwesomeIcon icon={faArrowRight} className="grey-arrw" />
            </a>
          </div>
        </div>
      </div>
    ));
  }

  if (heroMobile.length > 0) {
    heroMobileBannerDisplay = heroMobile.map((banner, i) => (
      <div className="mp-cover">
        <img className="mp-bg" src={banner.image.mediaItemUrl} />
        <div className="mp-content">
          <div className="mp-txt">
            <h1 className="mp-h1" data-aos="zoom-in" data-aos-delay="200"> {banner.heading} </h1>
            <p className="grey-p" data-aos="fade-up" data-aos-delay="200">{banner.caption}</p>
            <a href={banner.buttonLink} className="btn-trns" data-aos="fade-up" data-aos-delay="200">
              {" "}
              {banner.buttonName}{" "}
              <FontAwesomeIcon icon={faArrowRight} className="grey-arrw" />
            </a>
          </div>
        </div>
      </div>
    ));
  }

  if (listSections.length > 0) {
    listSectionsDisplay = listSections.map((section, i) =>
      i % 2 ? (
        <div
          id="mobile-view"
          className=" d-flex align-items-center justify-content-between padding-section-standard-top pb-5"
        >
          <div className="d-flex d-none d-sm-block justify-content-end">
            <img className="img-fluid" src={section.image.mediaItemUrl} />
          </div>

          <div className="pension-div1 pb-5">
            <h3 className="rma-h3 pb-2" data-aos="fade-up" data-aos-delay="200"> {section.heading} </h3>

            <hr
              className="btm-bdr"
              style={{ borderTop: "none", width: "600px" }}
            />

            <ul
              className="pt-2 custom-square"
              style={{ listStyleType: "square", paddingLeft: "20px" }}
            >
              {section.list.map((items, i) => (
                <li className="grey-p-rma pt-4" style={{ color: "#3B475A" }} data-aos="fade-up" data-aos-delay="200">
                  {items.list}
                </li>
              ))}
            </ul>
          </div>

          <div className="d-flex d-block d-sm-none justify-content-end">
            <img className="img-fluid" src={section.image.mediaItemUrl} />
          </div>
        </div>
      ) : (
        <div
          id="mobile-view"
          className=" d-flex align-items-center justify-content-between pb-5"
        >
          <div className="pension-div1 pb-5">
            <h3 className="rma-h3 pb-2" data-aos="fade-up" data-aos-delay="200">{section.heading}</h3>

            <hr
              className="btm-bdr"
              style={{ borderTop: "none", width: "600px" }}
            />

            <ul
              className="pt-2 custom-square"
              style={{ listStyleType: "square", paddingLeft: "20px" }}
            >
              {section.list.map((items, i) => (
                <li className="grey-p-rma pt-4" style={{ color: "#3B475A" }} data-aos="fade-up" data-aos-delay="200">
                  {items.list}
                </li>
              ))}
            </ul>
          </div>

          <div className="d-flex justify-content-end">
            <img className="img-fluid" src={section.image.mediaItemUrl} />
          </div>
        </div>
      ),
    );
  }

  if (businessSections.length > 0) {
    businessSectionsDisplay = businessSections.map((section, i) =>
      i % 2 ? (
        <div
          id="mobile-view"
          className=" d-flex align-items-center justify-content-between padding-section-standard-top pb-5 z-value"
        >
          <div className="values compact-section">
            <h3 className="mp-h3 mp-h3" data-aos="fade-up" data-aos-delay="200">{section.heading} </h3>
            <p
              className="grey-p pt-3 pb-5"
              style={{ fontSize: "16px", color: "#545454" }}
              data-aos="fade-up" data-aos-delay="200"
            >
              {section.caption}
            </p>

            <a
              class="open-acc-btn grey-p mt-3"
              href={section.buttonLink}
              role="button"
          
              data-aos="fade-up" data-aos-delay="200"
            >
              {section.buttonName}{" "}
              <FontAwesomeIcon className="mp-dwn-arr" icon={faArrowRight} />
            </a>
          </div>

          <div className="d-flex justify-content-end">
            <img className="img-fluid" src={section.image.mediaItemUrl} />
          </div>
        </div>
      ) : (
        <div
          id="mobile-view"
          className=" d-flex align-items-center justify-content-between padding-section-standard-top pb-5 z-value"
        >
          <div className="values-mp compact-section">
            <h3 className="mp-h3 mp-h3" data-aos="fade-up" data-aos-delay="200">{section.heading}</h3>
            <p
              className="grey-p pt-3 pb-5"
              style={{ fontSize: "16px", color: "#545454" }}
              data-aos="fade-up" data-aos-delay="200"
            >
              {section.caption}
            </p>

            <a
              class="open-acc-btn grey-p mt-3"
              href={section.buttonLink}
              role="button"
              data-aos="fade-up" data-aos-delay="200"
            >
              {section.buttonName}{" "}
              <FontAwesomeIcon className="mp-dwn-arr" icon={faArrowRight} />
            </a>
          </div>

          <div className="d-flex justify-content-end">
            <img className="img-fluid" src={section.image.mediaItemUrl} />
          </div>
        </div>
      ),
    );
  }

  return (
    <>
      <div className="mp-container d-block d-sm-none">
        {heroMobileBannerDisplay}
      </div>

      <div className="mp-container d-none d-sm-block">{heroBannerDisplay}</div>

      <div className="containeer">
        <div
          id="mobile-view"
          className="d-flex justify-space-between pt-5 padding-section-standard-bottom"
        >
          <div className=" width-fifty">
            <h2 className="mp-h2 pb-4">What is Micro Pension? </h2>
          </div>
          <div className=" width-fifty abt-para">
            <p className="grey-p grey-color">{productText}</p>
          </div>
        </div>

        <div id="" className=" ">
          {listSectionsDisplay}
        </div>

        <div
          id="mobile-view"
          className=" d-flex align-items-center justify-content-between padding-section-standard-top pb-5 z-value"
        >
          <div className="d-flex d-none d-sm-block justify-content-end">
            <img className="img-fluid" src={mpSteps} />
          </div>

          <div className="pension-div1 pb-5">
            <h3 className="mp-h3 pb-5">
              3 Ways to make your Micro Pension contribution
            </h3>

            <hr
              className="btm-bdr"
              style={{ borderTop: "none", width: "600px" }}
            />

            <ul
              className="pt-5 custom-square"
              style={{ listStyleType: "square", paddingLeft: "20px" }}
            >
              <li className="p-grey " style={{ color: "#3B475A" }}>
                REMITA Platform <br />
                <span className="orange-highlight"> Use Remita </span> to make
                direct contributions.
              </li>
              <li className="p-grey pt-4" style={{ color: "#3B475A" }}>
                PENPAY Platform <br />
                <span className="orange-highlight"> Use PenPay </span> or
                Download the{" "}
                <span className="orange-highlight"> PenPay App. </span>
              </li>
              <li className="p-grey pt-4" style={{ color: "#3B475A" }}>
                First Bank <br />
                Visit any First Bank branch or use the{" "}
                <span className="orange-highlight">
                  {" "}
                  First Bank Mobile App.{" "}
                </span>
              </li>
            </ul>
          </div>

          <div className="d-flex d-block d-sm-none justify-content-end">
            <img className="img-fluid" src={mpSteps} />
          </div>
        </div>

        {businessSectionsDisplay}
      </div>
                
      <Footer/>
           <div className='height-prod'> 

              </div>
    </>
  );
};

export default Mp;
